import React from 'react';
import { CheckIcon } from 'lucide-react';
export const Story = () => {
  return <section id="learn-more" className="py-12 sm:py-16 bg-white overflow-hidden" data-id="element-198">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-199">
        <div className="text-center mb-8 sm:mb-12" data-id="element-200">
          <h2 className="text-2xl font-extrabold tracking-tight text-gray-900 sm:text-3xl md:text-4xl" data-id="element-201">
            This isn't just a book. It's a legacy you can hold in your hands.
          </h2>
          <p className="mt-4 max-w-3xl mx-auto text-lg sm:text-xl text-gray-500" data-id="element-202">
            A timeless keepsake meant to be passed down from parents and
            grandparents to the children who will carry tomorrow's values.
          </p>
        </div>
        <div className="mt-8 sm:mt-12" data-id="element-203">
          <div className="prose prose-lg prose-indigo mx-auto text-gray-500" data-id="element-204">
            <p className="text-base sm:text-lg" data-id="element-205">
              Every family has stories, wisdom, and beliefs that deserve to live
              on. Yet too often, those lessons fade away with time.
            </p>
            <p className="text-base sm:text-lg" data-id="element-206">
              This book captures the heart of what matters most:
            </p>
            <ul className="mt-6 space-y-4" data-id="element-207">
              <li className="flex items-start" data-id="element-208">
                <div className="flex-shrink-0" data-id="element-209">
                  <div className="flex items-center justify-center h-10 w-10 sm:h-12 sm:w-12 rounded-md bg-[#0A2463] text-white" data-id="element-210">
                    <CheckIcon className="h-5 w-5 sm:h-6 sm:w-6" data-id="element-211" />
                  </div>
                </div>
                <div className="ml-4" data-id="element-212">
                  <h3 className="text-base font-medium text-gray-900 sm:text-lg" data-id="element-213">
                    Faith that sustains through trials.
                  </h3>
                </div>
              </li>
              <li className="flex items-start" data-id="element-214">
                <div className="flex-shrink-0" data-id="element-215">
                  <div className="flex items-center justify-center h-10 w-10 sm:h-12 sm:w-12 rounded-md bg-[#0A2463] text-white" data-id="element-216">
                    <CheckIcon className="h-5 w-5 sm:h-6 sm:w-6" data-id="element-217" />
                  </div>
                </div>
                <div className="ml-4" data-id="element-218">
                  <h3 className="text-base font-medium text-gray-900 sm:text-lg" data-id="element-219">
                    Freedom that must be protected.
                  </h3>
                </div>
              </li>
              <li className="flex items-start" data-id="element-220">
                <div className="flex-shrink-0" data-id="element-221">
                  <div className="flex items-center justify-center h-10 w-10 sm:h-12 sm:w-12 rounded-md bg-[#0A2463] text-white" data-id="element-222">
                    <CheckIcon className="h-5 w-5 sm:h-6 sm:w-6" data-id="element-223" />
                  </div>
                </div>
                <div className="ml-4" data-id="element-224">
                  <h3 className="text-base font-medium text-gray-900 sm:text-lg" data-id="element-225">
                    The American Dream that inspires courage and purpose.
                  </h3>
                </div>
              </li>
            </ul>
            <p className="mt-8 text-base sm:text-lg" data-id="element-226">
              By gifting this to your children or grandchildren, you aren't just
              handing them a book — you're planting seeds of conviction,
              character, and strength that will guide them for a lifetime.
            </p>
          </div>
        </div>
      </div>
    </section>;
};